/* eslint-disable-next-line no-unused-vars */
export const negociateLanguages = (...args) => "en-GB";

/* eslint-disable-next-line no-unused-vars */
export const getString = (id, ...args) => id;
